export const safeObject = (obj: unknown): object => {
  return obj && typeof obj === 'object' && Object.keys(obj).length > 0 ? obj : {};
};
